import { defineStore } from "pinia";
import { ref, computed } from "vue";

/**
 * @description
 * refetch trigger store
 */
const useRefetchTriggerStore = defineStore("refetchTrigger", () => {
    const navigateTrigger = ref<number>(0);

    /**
     * @description Getter (computed Value)
     */
    const isTriggered = computed(() => navigateTrigger.value > 0);

    /**
     * @description
     * route 이동 시 trigger 값을 증가시킵니다. (이를 통해 강제 key 업데이트로서 페이지 컴포넌트 리렌더링)
     */
    const routerPush = () => {
        navigateTrigger.value++;
    };

    /**
     * @description
     * trigger 값을 초기화 합니다.
     */
    const resetPath = () => {
        navigateTrigger.value = 0;
    };

    /**
     * @description
     * 전달받는 trigger 상태에 따라 실행시킬 함수를 결정합니다.
     */
    const determineExecuteTrigger = (trigger: "routerPush" | "resetPath") => {
        if (trigger === "routerPush") {
            routerPush();
        } else {
            resetPath();
        }
    };

    /**
     * @description
     * trigger 값을 설정합니다.
     */
    const setTrigger = (trigger: number) => {
        navigateTrigger.value = trigger;
    };

    return {
        navigateTrigger,
        isTriggered,
        routerPush,
        resetPath,
        setTrigger,
        determineExecuteTrigger,
    };
});

export default useRefetchTriggerStore;
